import React from "react";

const Disclaimer = () => {
  return (
    <section className="w-full bg-[#f3efed] py-6 px-4">
      <div className="max-w-5xl mx-auto text-center">
        {/* Logo */}
        <h2 className="text-2xl md:text-3xl font-semibold tracking-wide mb-4">
          <span className="text-[#090C6A]">SIDDHA</span>{" "}
          <span className="text-gray-900">SKY</span>
        </h2>

        {/* QR Code */}
        <div className="flex justify-center mb-4">
          <img
            src="/Images/QR/3.png"
            alt="Siddha Sky rera"
            className="w-28 h-28 md:w-32 md:h-32 object-contain"
          />
        </div>

        {/* RERA Info */}
        <p className="text-sm md:text-base text-gray-700">
          This project is RERA registered.
        </p>

        <p className="font-medium mt-1 text-sm md:text-base">
          Agent RERA Number: <span className="font-semibold">A52000032416</span>
        </p>

        <p className="font-medium text-sm md:text-base mb-5">
          Project RERA Number:{" "}
          <span className="font-semibold">P51900021027, P51900021040, P51900021044, P51900021031</span>
        </p>

        {/* Disclaimer Text */}
        <p className="text-xs md:text-sm text-gray-600 leading-relaxed max-w-4xl mx-auto mb-3">
          Disclaimer: This website is meant only for information purposes. It
          should not be considered / claimed as an official site. This website
          belongs to the authorized channel partner of Siddha Group. The content
          provided on this website is for information purposes only and does not
          constitute an offer to avail any service. The prices mentioned are
          subject to change without prior notice and the availability of
          properties mentioned is not guaranteed. The images displayed on the
          website are for representation purposes only and may not reflect the
          actual properties accurately. We may share data with Real Estate
          Regulatory Authority (RERA) registered brokers/companies for further
          processing as required. We may also send updates and information to
          the mobile number or email ID registered with us. All rights reserved.
          The content, design and information on this website are protected by
          copyright and other intellectual property rights. Any unauthorized use
          or reproduction of the content may violate applicable laws.
        </p>
      </div>
    </section>
  );
};

export default Disclaimer;
